import { useState } from 'react'
import type { ModelsData } from '../types'

interface HeaderProps {
  onClientClick?: () => void;
  isAdminLoggedIn?: boolean;
  isClientLoggedIn?: boolean;
  onShowProductCodeModal?: () => void;
  modelsData?: ModelsData;
  onProductSelect?: (groupKey: string, modelKey: string) => void;
}

const Header = ({ onClientClick, isAdminLoggedIn, isClientLoggedIn, onShowProductCodeModal, modelsData, onProductSelect }: HeaderProps) => {
  const [searchTerm, setSearchTerm] = useState('')
  const [showResults, setShowResults] = useState(false)
  
  let buttonText = "Panel Logowania"
  let buttonTitle = "Panel Logowania"
  
  if (isAdminLoggedIn) {
    buttonText = "Otwórz Panel Admina"
    buttonTitle = "Otwórz panel administratora"
  } else if (isClientLoggedIn) {
    buttonText = "Otwórz Panel Klienta"
    buttonTitle = "Otwórz panel klienta"
  }

  // Search through all models
  const allResults = searchTerm.trim() ? 
    Object.entries(modelsData || {}).flatMap(([groupKey, models]) =>
      Object.entries(models).filter(([modelKey, model]) => {
        const searchLower = searchTerm.toLowerCase()
        return (
          model.name.toLowerCase().includes(searchLower) ||
          modelKey.toLowerCase().includes(searchLower) ||
          (model.id || '').toLowerCase().includes(searchLower) ||
          (model.specs?.power || '').toString().toLowerCase().includes(searchLower) ||
          groupKey.toLowerCase().includes(searchLower) ||
          (model.description || '').toLowerCase().includes(searchLower)
        )
      }).map(([modelKey, model]) => ({ groupKey, modelKey, model }))
    )
    : []
  
  console.log('Search results:', allResults.length)
  const searchResults = allResults // No limit - show all results

  const handleProductSelect = (groupKey: string, modelKey: string) => {
    onProductSelect?.(groupKey, modelKey)
    setSearchTerm('')
    setShowResults(false)
  }
  
  return (
    <header className="header">
      <div className="header-top">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
          {/* Left side - Search and Product Code */}
          <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
            {/* Product Search */}
            <div className="product-search-container" style={{ position: 'relative' }}>
              <input
                type="text"
                className="product-search-input responsive-search-width"
                placeholder="Szukaj..."
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value)
                  setShowResults(e.target.value.trim().length > 0)
                }}
                onFocus={() => setShowResults(searchTerm.trim().length > 0)}
                onBlur={() => setTimeout(() => setShowResults(false), 150)}
                style={{
                  padding: '3px 8px',
                  border: '1px solid var(--line)',
                  borderRadius: '5px',
                  fontSize: '12px',
                  width: '200px',
                  height: '26px',
                  boxSizing: 'border-box'
                }}
              />
              
              {showResults && searchResults.length > 0 && (
                <div className="product-search-results" style={{
                  position: 'absolute',
                  top: '100%',
                  left: 0,
                  right: 0,
                  background: 'var(--card)',
                  border: '1px solid var(--line)',
                  borderRadius: '0',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                  zIndex: 1000,
                  maxHeight: '300px',
                  overflowY: 'auto'
                }}>
                  {searchResults.map(({ groupKey, modelKey, model }) => (
                    <div
                      key={`${groupKey}-${modelKey}`}
                      className="search-result-item"
                      onClick={() => handleProductSelect(groupKey, modelKey)}
                      style={{
                        padding: '8px 12px',
                        cursor: 'pointer',
                        borderBottom: '1px solid var(--line)',
                        fontSize: '13px'
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'var(--accent-light)'}
                      onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                    >
                      <div style={{ fontWeight: 500, color: 'var(--fg)' }}>{model.name}</div>
                      <div style={{ fontSize: '11px', color: 'var(--muted)' }}>
                        {model.power} • {groupKey}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
            
            {/* Product Code Button */}
            {onShowProductCodeModal && (
              <button 
                className="product-code-btn"
                onClick={onShowProductCodeModal}
                title="Wprowadź Kod Produktu"
                style={{ 
                  fontSize: '12px', 
                  padding: '6px 12px',
                  background: 'var(--preview-bg)',
                  color: 'var(--preview-fg)',
                  border: '1px solid var(--preview-line)',
                  borderRadius: '6px',
                  cursor: 'pointer'
                }}
              >
                Kod Produktu
              </button>
            )}
          </div>
          
          {/* Right side - Instruction and Login Buttons */}
          <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
            <button 
              className="admin-login-btn instruction-btn-desktop"
              onClick={() => {
                const event = new CustomEvent('showInstructionModal')
                window.dispatchEvent(event)
              }}
              title="Jak korzystać z konfiguratora"
            >
              Jak korzystać?
            </button>
            <button 
              className="admin-login-btn"
              onClick={onClientClick}
              title={buttonTitle}
            >
              {buttonText}
            </button>
          </div>
        </div>
      </div>
      <div className="header-content">
        <h1>Konfigurator Wkładu Kominkowego UNICO</h1>
        <p>Wybierz model i skonfiguruj według swoich potrzeb</p>
      </div>
    </header>
  )
}

export default Header
